import { PATHS } from "util/appConstants";
import {
  selectCurrent,
  selectCompleted,
  selectArchived,
  selectCurrentPagination,
  selectRecentPagination,
  selectArchivedPagination,
} from "redux/slices/routeSlice";
import {
  CURRENT_TOURS_COLUMNS_CURRENT_TOURS_TAB,
  CURRENT_TOURS_COLUMNS_CURRENT_TOURS_TAB_BOTH_KEY_PDF,
} from "constants/ui-constants";
import { RECENTLY_FINISHED_ROUTES_COLUMNS } from "constants/ui-constants";
import { ARCHIVED_ROUTES_COLUMNS } from "constants/ui-constants";

export const ROUTE_CONFIGS = {
  current: {
    selector: selectCurrent,
    paginationSelector: selectCurrentPagination,
    loadAction: 'current',
    columns: CURRENT_TOURS_COLUMNS_CURRENT_TOURS_TAB,
    columnsWithPDF: CURRENT_TOURS_COLUMNS_CURRENT_TOURS_TAB_BOTH_KEY_PDF,
    mapPath: PATHS.tours.map,
    features: {
      favourites: true,
      undo: true,
      reorder: true,
      socketUpdates: true,
      skipButton: true
    }
  },
  recent: {
    selector: selectCompleted,
    paginationSelector: selectRecentPagination,
    loadAction: 'recent',
    columns: RECENTLY_FINISHED_ROUTES_COLUMNS,
    mapPath: PATHS.routes.mapRecent,
    features: {
      supplierSupport: true
    }
  },
  archived: {
    selector: selectArchived,
    paginationSelector: selectArchivedPagination,
    loadAction: 'archived',
    columns: ARCHIVED_ROUTES_COLUMNS,
    mapPath: PATHS.routes.mapArchive,
    features: {}
  }
};
